<template>
  <div>
    <a-modal v-model="visible" title="Pocket Money" onOk="handleOk" :width="this.settings['isMobileView'] ? 480 : 720" :destroyOnClose="true" :maskClosable="false">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Close</a-button>
      </template>
      <template >
        <div class="row">
          <div class="col-12 col-md-6">
            <p>Total Balance: {{ data.length > 0 ? data[0].balance_amount : 'N/A' }}</p>
          </div>

          <div class="col-12 col-md-6 text-right">
            <div class="d-inline-flex flex-row">
              <div class="mr-2">
                <outward-pocket-money-modal />
              </div>
              <div class="mr-2">
                <inward-pocket-money-modal />
              </div>
            </div>
          </div>
        </div>
      </template>
      <a-divider />
      <template>
        <div>
          <div class="air__utils__scrollTable my-4">
            <a-table
              :rowKey="record => record.id"
              :columns="columns"
              :dataSource="data"
              :pagination="false"
              :scroll="{ x: '100%', y: 240 }"
              :rowSelection="computedSelect"
              :loading="loading"
            >
              <template slot="student" slot-scope="student">
                <div class="text-wrap">{{ student.first_name + ' ' + student.last_name }}</div>
              </template>
            </a-table>
          </div>
        </div>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import inwardPocketMoneyModal from '@/components/hostel/manage/pocket-money/inward'
import outwardPocketMoneyModal from '@/components/hostel/manage/pocket-money/outward'
const columns = [
  { title: 'Transaction', width: 100, className: 'text-wrap', dataIndex: 'transaction_id', scopedSlots: { customRender: 'transaction_id' } },
  { title: 'Amount', width: 100, className: 'text-center text-wrap', dataIndex: 'amount', scopedSlots: { customRender: 'amount' } },
  { title: 'Bal. Amt.', width: 100, className: 'text-center text-wrap', dataIndex: 'balance_amount', scopedSlots: { customRender: 'balance_amount' } },
  { title: 'D/T', width: 100, className: 'text-center text-wrap', dataIndex: 'transaction_date_time', scopedSlots: { customRender: 'transaction_date_time' } },
  { title: 'Type', width: 100, className: 'text-center text-wrap', dataIndex: 'type', scopedSlots: { customRender: 'type' } },
  { title: 'Remark', width: 100, className: 'text-center text-wrap', dataIndex: 'remark', scopedSlots: { customRender: 'remark' } },
]

export default {
  name: 'pocketMoneyModal',
  components: {
    inwardPocketMoneyModal,
    outwardPocketMoneyModal,
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
      visible: false,
      loading: false,
      data: [],
      selectedRowKeys: [],
      columns,
    }
  },
  computed: {
    ...mapState(['settings', 'user']),
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  mounted() {
    this.$eventBus.$on('openModal', this.showPocketMoneyModal)
  },
  methods: {
    showPocketMoneyModal(recordId) {
      this.visible = true
      this.getPocketMoney(recordId)
    },
    getPocketMoney: function(record) {
      this.selectedRowKeys = []
      this.loading = true
      this.$http.get(`/api/hostel/pocket-money/single`, {
        params: {
          limit: this.pageSize,
          hostel_enrollment_id: record.id,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data || []
        this.meta = data.meta || {}
      }).catch(error => {
        console.error('Error fetching pocket money:', error)
        this.loading = false
      })
    },

    handleCancel(e) {
      this.visible = false
    },
  },
}
</script>
